export enum PropertyValueType {
  AutoId = 'auto-id',
  Boolean = 'boolean',
  Formula = 'formula',
  Link = 'link',
  Date = 'date',
  Mail = 'mail',
  Number = 'number',
  Checkbox = 'checkbox',
  Text = 'text',
  Textarea = 'textarea',
  Markdown = 'markdown',
  File = 'file',
  Person = 'person',
  People = 'people',
  Phone = 'phone',
  Location = 'location',
  Rating = 'rating',
  Relation = 'relation',
  TimeTracker = 'time-tracker',
  ReverseRelation = 'reverse-relation',
  Status = 'status',
  Dropdown = 'dropdown',
  Error = 'error',
  Comments = 'comments',
  Summary = 'summary',
  EntityWithDate = 'entity-with-date',
  ColorGroup = 'color-group',
  CreatedAt = 'created-at',
  UpdatedAt = 'updated-at',
  Checklist = 'checklist',
  Vote = 'vote',
  TimeTrackerSum = 'time-tracker-sum',
  Button = 'button',
  Watchers = 'watchers',
}
